import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function newProject(data) {
  return request({
    url: URL.projectManage.newProject,
    method: 'post',
    data
  })
}

export function removeProject(uuid) {
  return request({
    url: URL.projectManage.remove + '/' + uuid,
    method: 'post'
  })
}

export function update(requestBody) {
  return request({
    url: URL.projectManage.update,
    method: 'post',
    data: requestBody
  })
}
export function detail(uuid) {
  return request({
    url: URL.projectManage.detail + '/' + uuid,
    method: 'get'
  })
}
export function getAllProject() {
  return request({
    url: URL.projectManage.getAll,
    method: 'get'
  })
}
export function getAllProjectByCon(data) {
  return request({
    url: URL.projectManage.getAllProjectByCon,
    method: 'post',
    data
  })
}
// 获取项目名称
export function getProjectNames() {
  return request({
    url: URL.projectManage.getProjectNames,
    method: 'get'
  })
}
export function advancedQuery(data) {
  return request({
    url: URL.projectManage.advancedQuery,
    method: 'post',
    data
  })
}
export function findByProjectNo(data) {
  return request({
    url: URL.projectManage.findByProjectNo,
    method: 'post',
    data
  })
}

export function validateDelProject(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.projectManage.validateDelProject,
    method: 'post',
    data
  })
}

export function batchDeleteProject(data) {
  return request({
    url: URL.projectManage.batchDeleteProject,
    method: 'delete',
    data
  })
}

export function batchCloseProject(data) {
  return request({
    url: URL.projectManage.batchCloseProject,
    method: 'post',
    data
  })
}

export function batchOpenProject(data) {
  return request({
    url: URL.projectManage.batchOpenProject,
    method: 'post',
    data
  })
}
export function asyncCharge(data) {
  return request({
    url: URL.projectManage.asyncCharge,
    method: 'post',
    data: data
  })
}

export function getPartnerByPoNo(data) {
  return request({
    url: URL.projectManage.getPartnerByPoNo,
    method: 'get',
    params: { poNo: data }
  })
}
